var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouth1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 20,
    viewBox: "0 0 60 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8382 5.91866C53.2907 5.91866 57.7527 4.85853 57.6578 5.87119C56.5343 6.75726 51.5502 11.0136 50.1894 12.4376C36.123 21.156 22.1199 22.1053 9.77811 9.82688C8.86039 8.90916 8.00597 7.59587 7.16737 6.56739C21.6768 6.09271 36.3287 5.85537 50.8382 5.91866Z",
    fill: "#FBFBFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6581 5.85494C43.1328 5.79165 21.6771 6.09227 7.16766 6.56696C6.69297 5.98151 6.04423 5.41189 5.87018 4.60493C17.6581 3.90872 19.7151 -3.16404 32.9271 1.99418C38.0378 -2.48366 55.7435 1.36128 57.6739 5.85494H57.6581Z",
    fill: "#CF8065"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87023 4.60569C6.04428 5.39683 6.69302 5.96645 7.1677 6.56772C7.99049 7.5962 8.86073 8.90948 9.77845 9.8272C6.23415 9.6848 3.57594 6.01392 0 4.28924C0.696201 3.15 3.54428 4.74811 5.87023 4.62153V4.60569Z",
    fill: "#402D27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1893 12.4218C51.5501 10.9978 54.2874 7.45348 55.4108 6.55158C64.2241 -0.473722 59.1608 6.86802 50.1893 12.4218Z",
    fill: "#402D27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouth1);
export default __webpack_public_path__ + "static/media/mouth-1.95e0734ad0c8a8d4144f70f1daccb67c.svg";
export { ForwardRef as ReactComponent };